<template>
  <div name="step2">
    <StepBox :step="step" />
    <div class="terms-box bottom-xl">
      <i18n
        tag="h5"
        path="demo.demoRegistration.step2.checkboxes.facialRegistrationAndVerificationPurposes" />
      <div class="card-box">
        <p>
          {{
            $t(
              'demo.demoRegistration.step2.facialRegistrationAndVerificationPurposes.row1',
            )
          }}
        </p>
      </div>
    </div>

    <div class="terms-box bottom-xl">
      <div class="form-check form-check-lg">
        <input id="check-111" type="checkbox" v-model="agreement" />
        <label for="check-111">
          <i18n
            tag="span"
            path="demo.demoRegistration.step2.checkboxes.personalInformationCollectionAndUsageAgreement">
            <template #mandatory>
              <strong>{{
                $t('demo.demoRegistration.step2.checkboxes.mandatory')
              }}</strong>
            </template>
          </i18n>
        </label>
      </div>
      <div class="card-box">
        <p>
          <i18n
            path="demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.row1">
            <template #companyName>{{ companyName }}</template>
          </i18n>
          <br />
          {{
            $t(
              'demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.row2',
            )
          }}
        </p>
        <table class="table">
          <caption>
            {{
              $t(
                'demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.title',
              )
            }}
          </caption>
          <thead>
            <tr>
              <th scope="col">
                {{
                  $t(
                    'demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.th1',
                  )
                }}
              </th>
              <th scope="col">
                {{
                  $t(
                    'demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.th2',
                  )
                }}
              </th>
              <th scope="col" style="width: 177px">
                {{
                  $t(
                    'demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.th3',
                  )
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">
                {{
                  $t(
                    'demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.td1',
                  )
                }}
              </td>
              <td>
                <ul class="bull">
                  <li>
                    {{
                      $t(
                        'demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.td2',
                      )
                    }}
                  </li>
                  <li>
                    {{
                      $t(
                        'demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.td2-1',
                      )
                    }}
                  </li>
                </ul>
              </td>
              <td>
                <span class="strong-text">{{
                  $t(
                    'demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.td3',
                  )
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import stepMixin from '@/mixins/step_demo';

  export default {
    name: 'Step2',
    mixins: [stepMixin],
    props: {
      companyName: String,
    },
    data() {
      return {
        agreementForExam: false,
      };
    },
    computed: {
      agreement: {
        get() {
          return this.agreementForExam;
        },
        set(value) {
          this.agreementForExam = value;
          this.$nextTick(() => this.validated(value));
        },
      },
    },
    activated() {
      document.querySelectorAll('.ps')[0].scrollTop = 0;
      this.$emit('show-buttons', true);
      if (this.stepNavigation.from > this.stepNavigation.to) {
        this.agreementForExam = true;
        this.validated(this.agreementForExam);
      } else {
        this.validated(this.agreementForExam);
      }
    },
  };
</script>
